//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TencentPlayer',
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      tcPlayerId: 'tcPlayer' + Date.now(),
      player: null
    }
  },
  // watch: {
  //     options: {
  //         handler(newV, oldV) {
  //             this.$nextTick(() => {
  //                 this.loadJS();
  //             });
  //         },
  //         immediate: true,
  //         deep: true,
  //     },
  // },
  methods: {
    onoptions (cur, old) {
      this.$nextTick(() => {
        this.loadJS()
      })
    },
    loadTcScript (callback) {
      this.loadScript(callback, {
        id: 'tcPlayerScriptId',
        id2: 'tcPlayerScript2Id',
        url: '',
        url2: '//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.v4.min.js'
      })
    },
    loadScript (callback, params) {
      if (document.getElementById(params.id)) {
        callback()
      } else {
        const script = document.createElement('script')
        script.async = true
        script.src = params.url
        script.id = params.id
        script.onload = () => {
          callback()
        }
        document.body.appendChild(script)
        const script2 = document.createElement('script')
        script2.async = true
        script2.src = params.url2
        script2.id = params.id2
        script2.onload = () => {
          callback()
        }
        document.body.appendChild(script2)
      }
    },
    loadJS () {
      if (window.TCPlayer) {
        this.initVideo()
      } else {
        this.loadTcScript(() => {
          this.initVideo()
        })
      }
    },
    initVideo () {
      const playerParm = {
        fileID: this.options.fileID,
        appID: this.options.appID,
        autoplay: !!this.options.autoplay,
        language: this.$store.state.LanguageCode,
        plugins: {
          ContinuePlay: {
            auto: false // 是否在播放时自动续播
          },
          ProgressMarker: true, // 控制进度条显示
          ContextMenu: {
            statistic: true // Boolean 控制是否支持显示数据面板
            // levelSwitch: {
            //   open: true // 打开切换提示
            // }
          }
        }
      }
      if (this.options.fileID && this.options.appID) {
        console.log(playerParm, 9999)
        setTimeout(() => {
          if (!this.player) {
            this.player = window.TCPlayer && window.TCPlayer('tcPlayerId', playerParm)
          } else {
            this.player.loadVideoByID(playerParm)
          }
        })
      } else if (this.options.url) {
        const player = window.TCPlayer && window.TCPlayer('tcPlayerId', {}) // player-container-id 为播放器容器 ID，必须与 html 中一致
        player && player.src(this.options.url) // url 播放地址
      }
    }
  }
}
